var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 13.914",
    fill: "currentColor",
    stroke: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase_2_",
    "data-name": "briefcase (2)",
    transform: "translate(0.001 -32.857)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M14.516,35.445H11.07V34.056a1.2,1.2,0,0,0-1.2-1.2H6.353a1.2,1.2,0,0,0-1.2,1.2v1.389H1.708A1.594,1.594,0,0,0,.116,37.037v8.143a1.594,1.594,0,0,0,1.592,1.592H14.516a1.594,1.594,0,0,0,1.592-1.592V37.037A1.594,1.594,0,0,0,14.516,35.445ZM6.17,34.056a.184.184,0,0,1,.183-.183H9.871a.184.184,0,0,1,.183.183v1.389H6.17ZM1.132,37.037a.577.577,0,0,1,.576-.576H14.516a.577.577,0,0,1,.576.576v.752a1.6,1.6,0,0,1-1.15,1.532L8.632,40.867a1.856,1.856,0,0,1-1.04,0L2.281,39.32a1.6,1.6,0,0,1-1.15-1.532Zm13.385,8.719H1.708a.577.577,0,0,1-.576-.576V39.856A2.6,2.6,0,0,0,2,40.3C7.864,42,7.563,41.956,8.112,41.956s.241.049,6.115-1.661a2.6,2.6,0,0,0,.866-.439v5.323A.577.577,0,0,1,14.516,45.756Z",
    transform: "translate(-0.113 0)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.2b0a0fb6d95ad45fca2e8bb2fba72b1c.svg";
export { ForwardRef as ReactComponent };